<template>
  <v-container fluid grid-list-md>
    <v-layout wrap>
      <v-flex xs12>
        <h3>Период оплаты: {{period_short}}</h3>
        <h3>Лицевой счет: {{this.address.account}}</h3>
        <h3>{{this.address.address}}</h3>
      </v-flex>
      <v-flex xs12 sm12 class="text-xs-right">
        <v-dialog v-model="dialog">
          <v-tabs
                  color="primary"
                  dark
                  slider-color="white">
            <v-tab href="#tab-1">
              Основные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-1'">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} {{receipt_item.id}}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12 sm8>
                        <v-select
                                v-model="receipt_item.service"
                                :items="services"
                                item-text="name"
                                item-value="id"
                                label="Услуга"
                                required
                                :error-messages="requiredErrors('service')"
                                @blur="$v.receipt_item.service.$touch()"
                        ></v-select>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-model.trim="receipt_item.oplata"
                                label="Оплата"
                                :error-messages="requiredErrors('oplata')"
                                @blur="$v.receipt_item.oplata.$touch()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-model.trim="receipt_item.tariff"
                                label="Тариф"
                                :error-messages="requiredErrors('tariff')"
                                @blur="$v.receipt_item.tariff.$touch()"
                        ></v-text-field>
                      </v-flex>
                      <v-flex xs12 sm8>
                        <v-text-field
                                v-model.trim="receipt_item.norm"
                                label="Норматив"
                                :error-messages="requiredErrors('norm')"
                                @blur="$v.receipt_item.norm.$touch()"
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn @click.native="close">Отменить</v-btn>
                  <v-btn @click.native="save">Сохранить</v-btn>
                  <v-btn
                          v-if="(receipt_item.id !== null)"
                          @click.native="del">Удалить</v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
            <v-tab href="#tab-2">
              Системные данные
            </v-tab>
            <v-tab-item
                    :value="'tab-2'">
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }} {{receipt_item.id}}</span>
                </v-card-title>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <table>
                          <tr>
                            <th>Пользователь</th>
                            <td>{{ receipt_item.user }}</td>
                          </tr>
                          <tr>
                            <th>Дата создания</th>
                            <td>{{ receipt_item.create_date|date_time }}</td>
                          </tr>
                          <tr>
                            <th>Дата модификации</th>
                            <td>{{ receipt_item.time_stamp|date_time }}</td>
                          </tr>

                        </table>
                      </v-flex>

                    </v-layout>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs>
        </v-dialog>
      </v-flex>
      <v-flex>
        <v-data-table
                :items="receipts.results"
                :server-items-length="receipts.last_page"
                :loading="listLoading.includes('fetchAddress') || listLoading.includes('fetchReceipts')"
                hide-default-footer
                v-model="receipts.results"
                no-results-text="Нет отфильтрованных данных"
                class="elevation-1">
          <template v-slot:header>
            <tr>
              <th>Код</th>
              <th>Услуга</th>
              <th>Оплата</th>
              <th>Тариф</th>
              <th>Норматив</th>
              <th>
                <v-btn
                        icon
                        class="mr-2"
                        @click="editItem(null)"
                >
                  <v-icon>mdi-pencil-plus</v-icon>
                </v-btn>
              </th>
            </tr>
          </template>
          <template v-slot:body="{ items }">
            <tbody>
              <tr  v-for="item in items" :key="item.id">
                <td>{{ item.id }}</td>
                <td>{{ item.service }}</td>
                <td>{{ item.oplata }}</td>
                <td>{{ item.tariff }}</td>
                <td>{{ item.norm }}</td>
                <td class="justify-center layout mx-0">
                  <v-btn
                          icon
                          class="mr-2"
                          @click="editItem(item)"
                  >
                    <v-icon>mdi-pencil</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>

          </template>
        </v-data-table>
        <div class="text-xs-center pt-2">
          <v-pagination
                  key="pagination"
                  v-model="pagination.page"
                  :length="receipts.last_page"
          ></v-pagination>
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
import { validationMixin } from 'vuelidate'
import { required, minValue } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      dialog: false,
      receipt_item: {
        id: null
      },
      default_receipt_item: {
        id: null
      },
      pagination: {
        rowsPerPage: 10,
        sortBy: null,
        totalItems: 0,
        page: 1
      }
    }
  },
  mixins: [validationMixin],
  validations: {
    // name: { required, maxLength: maxLength(10) },
    receipt_item: {
      oplata: { required, minValue: minValue(0.01) },
      service: { required },
      tariff: { required, minValue: minValue(0.01) },
      norm: { required, minValue: minValue(0.01) }
    }
  },
  watch: {
    pagination: {
      handler () {
        this.get_accounts()
      },
      deep: true
    },
    dialog (val) {
      // if (val) {
      //   this.fetchReceipt(this.receipt_id, this.receipt_item)
      // }
      val || this.close()
    }
  },
  methods: {
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v.receipt_item[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      if (field.hasOwnProperty('minValue')) {
        !field.minValue && errors.push('Убедитесь, что значение больше 0')
      }
      if (field.hasOwnProperty('email')) {
        !field.email && errors.push('Это не адрес электронной почты')
      }
      if (field.hasOwnProperty('validatorRus')) {
        !field.validatorRus && errors.push('Некорректные символы')
      }
      if (field.hasOwnProperty('validatorPhone')) {
        !field.validatorPhone && errors.push('Некорректные символы')
      }
      return errors
    },
    editItem: function (item) {
      this.dialog = true
      if (item == null) {
        this.receipt_item = JSON.parse(JSON.stringify(this.default_receipt_item))
      } else {
        this.receipt_item = JSON.parse(JSON.stringify(item))
      }
    },
    close () {
      this.dialog = false
      this.receipt_item = JSON.parse(JSON.stringify(this.default_receipt_item))
    },
    save () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$set(this.receipt_item, 'address', this.address.id)
        this.$store.dispatch('gku_receipts/insertReceipt', this.receipt_item)
          .then(() => {
            this.$store.dispatch('gku_receipts/fetchReceipts', this.address.id)
          })
          .catch(() => {
            this.$store.dispatch('gku_receipts/fetchReceipts', this.address.id)
          })
        this.close()
      }
    },
    del () {
      if (this.receipt_item.id !== null) {
        this.$store.dispatch('gku_receipts/deleteReceipt', this.receipt_item.id)
          .then(() => {
            this.$store.dispatch('gku_receipts/fetchReceipts', this.address.id)
          })
          .catch(() => {
            this.$store.dispatch('gku_receipts/fetchReceipts', this.address.id)
          })
        this.close()
      }
    },
    fetchReceipt (id, data) {
      if (id == null) {
        this.$store.commit('gku_receipts/setDefaultReceipt')
      } else { this.$store.commit('gku_receipts/setReceipt', data) }
      // this.$store.dispatch('gku_receipts/fetchReceipt', id)
    }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    },
    period_short () {
      return moment(this.address.period_payment).format('MMMM YYYY')
    },
    receipts () {
      return this.$store.getters['gku_receipts/receipts']
    },
    receipt () {
      return this.$store.getters['gku_receipts/receipt']
    },
    formTitle () {
      return this.receipt_item.id === null ? 'Добавить запись' : 'Запись'
    },
    address () {
      return this.$store.getters['gku_receipts/address']
    },
    services () {
      return this.$store.getters['gku_receipts/services']
    }
  },
  created: function () {
    this.$store.dispatch('gku_receipts/fetchAddress', this.$route.params)
      .then(() => {
        this.$store.dispatch('gku_receipts/fetchReceipts', this.address.id)
      }
      )
  }
}

</script>

<style>

</style>
